var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolliesLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 14,
    viewBox: "0 0 99 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70855 7.74231L3.01478 0.638672H0V13.3586H2.81808V7.1142L4.69634 12.2465H6.72077L8.59903 7.1142V13.3586H11.4171V0.638672H8.40232L5.70855 7.74231Z",
    fill: "#E62A36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1552 0.5C22.0583 0.5 21.0803 0.727045 20.1664 1.19065C18.2554 2.15049 17.1147 4.32305 17.1147 6.99864C17.1147 8.41257 17.3975 9.62801 17.9535 10.611C19.0463 12.5266 20.7961 13.4973 23.1552 13.4973C24.274 13.4973 25.2534 13.277 26.1495 12.8229C28.0578 11.8237 29.1971 9.64704 29.1971 6.99864C29.1971 5.6051 28.9089 4.38967 28.342 3.38768C27.2956 1.49791 25.5034 0.5 23.1552 0.5ZM23.1552 10.8666C22.2345 10.8666 21.4873 10.5525 20.874 9.90943C20.273 9.26229 19.9683 8.28341 19.9683 6.99864C19.9683 5.71387 20.273 4.73363 20.8726 4.08921C21.4873 3.44478 22.2345 3.13073 23.1552 3.13073C24.08 3.13073 24.8218 3.44342 25.4214 4.08921C26.0321 4.72955 26.3421 5.70843 26.3421 6.99864C26.3421 8.28885 26.0321 9.26773 25.4187 9.90943C24.8204 10.5539 24.08 10.8666 23.1552 10.8666Z",
    fill: "#E62A36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5895 0.638672H34.77V13.3586H42.7789V10.7279H37.5895V0.638672Z",
    fill: "#E62A36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.172 0.638672H48.3525V13.3586H56.3628V10.7279H51.172V0.638672Z",
    fill: "#E62A36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.756 0.638672H61.9365V13.3586H64.756V0.638672Z",
    fill: "#E62A36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6003 7.91497H77.8472V5.28289H73.6003V3.27076H78.8963V0.638672H70.7822V13.3586H79.0712V10.7279H73.6003V7.91497Z",
    fill: "#E62A36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8936 5.43677H85.0286L87.9683 0.648438H84.4317L82.8936 5.43677Z",
    fill: "#E62A36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.722 5.53577C93.5923 5.00418 93.0432 4.49163 93.0432 3.97229C93.0432 3.47605 93.412 3.13073 93.9407 3.13073C94.5171 3.13073 95.0048 3.51412 95.3927 4.27003L95.5293 4.5365L97.8215 3.08178L97.719 2.86561C96.9773 1.29534 95.7055 0.5 93.9407 0.5C92.8998 0.5 92.0542 0.838528 91.3507 1.5387C90.6732 2.23206 90.3303 3.08586 90.3303 4.07289C90.2893 6.62884 92.5733 7.58733 93.8 8.10259C94.554 8.42073 95.4515 8.93056 95.4515 9.55731C95.4515 10.4641 95.0458 10.8679 94.1333 10.8679C93.1128 10.8679 92.4039 10.1242 91.9668 8.59611L91.8671 8.24671L89.564 9.68919L89.6008 9.87273C89.8044 10.8856 90.3221 11.7557 91.1431 12.4627C91.9654 13.152 92.953 13.5 94.08 13.5C96.6249 13.5 98.2682 11.9039 98.2682 9.43767C98.2887 7.09925 96.0511 6.11901 94.722 5.53577Z",
    fill: "#E62A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolliesLogoText);
export default __webpack_public_path__ + "static/media/mollies_logo_text.ec2e3be0c50a2b09a4cc464ad8837357.svg";
export { ForwardRef as ReactComponent };